/*
  Kontrollu sonsuz kaydirma - Fahhar
  -------------------------------------------------------------------------
  Temanin kendi "tikla-yukle" (click) sayfalama modunun ustune ince bir katman.
  Urunleri tema yukler ve kartlari tema yeniden kurar (hizli gorunum vb.);
  bu dosya yalnizca NE ZAMAN yuklenecegine karar verir:

    - Her grupta AUTO_PAGES sayfa kendiliginden yuklenir (1 = ilk sayfa + 1,
      yani 2 sayfa), sonra "Daha fazla" butonu gorunur.
    - Butona basilinca bir sayfa yuklenir, ardindan yine AUTO_PAGES sayfa
      kendiliginden gelir, sonra tekrar buton.
    - Buton urunleri ayni sayfada asagi dogru eklemeye devam eder. Guvenlik
      siniri: tek belgede en cok MAX_CARDS kart (masaustu ve mobil 240);
      ancak ondan sonra buton normal bir sayfa gecisi yapar ve tarayici
      bellegi serbest kalir.
    - Adres, ekrandaki urunlerin sayfasina gore ?page=N olarak guncellenir;
      geri donuste / yenilemede kalinan urune kaydirilir.
    - Eklenen sayfalardaki kopya kart <style> bloklari atilir (ilk sayfadaki
      yeterli), sayfa sismez.
    - Hizli kaydirma: siradaki sayfa listenin sonuna PRELOAD_PX kala (erken),
      hizli kaydirmada ise kaydirma hizina gore daha da once istenir.
      Yukleme surerken izgaranin sonuna, gelecek urunlerin yerine ayni olcude
      gri yer tutucu kartlar (.fk-ss-skel) eklenir; urunler gelince ayni
      yerde onlarin yerini alir. Boylece listenin altindaki icerik (SEO
      metni, altlik) araya girmez.

  Bu dosya yuklenmezse tema butonu tek basina calismaya devam eder.
  Kapatmak icin: templates/collection.json ve search.json icinde
  "pagination": "paginated" (numarali sayfalar geri gelir).
  Gorunum: assets/fk-sonsuz-kaydirma.css
*/
(function () {
  'use strict';

  if (window.__fkSonsuzKaydirma) return;
  window.__fkSonsuzKaydirma = true;

  var AUTO_PAGES = 1;      // butondan once kendiliginden yuklenen sayfa sayisi
  var MAX_CARDS = 240;         // tek belgede tutulan en cok kart (masaustu)
  var MAX_CARDS_MOBILE = 240;  // ayni sinir, dar ekranda (telefon zorlanirsa dusur)
  var PRELOAD_PX = 2500;   // listenin sonuna en az bu kadar kala yuklemeye basla
  var PRELOAD_SCREENS = 3; // ...ya da bu kadar ekran boyu kala (hangisi buyukse)
  var FAST_PX_MS = 0.5;    // bu hizin (px/ms) ustu "hizli kaydirma" sayilir
  var FAST_AHEAD_MS = 3000; // hizli kaydirmada bu sure icinde varilacaksa simdi yukle
  var SKELETON_MAX = 60;   // bir seferde eklenen en cok yer tutucu kart
  var WATCHDOG_MS = 12000; // yukleme bu surede bitmezse normal baglantiya don
  var TOP_PX = 80;         // "ekranin ustundeki ilk kart" esigi

  var STORE_KEY = 'fk_ss_konum';
  var CONTINUE_KEY = 'fk_ss_devam';
  var STORE_TTL = 6 * 60 * 60 * 1000;

  var GRID = '.collection__infinite-container, .search__infinite-container';
  var TRIGGER = '.collection__infinite-trigger, .search__infinite-trigger';

  var isTr = (document.documentElement.lang || 'tr').toLowerCase().indexOf('tr') === 0;
  var TEXT = isTr
    ? { prev: 'Önceki ürünleri göster', loading: 'Ürünler yükleniyor', loaded: '{n} ürün daha yüklendi' }
    : { prev: 'Show previous products', loading: 'Loading products', loaded: '{n} more products loaded' };

  var hasIO = 'IntersectionObserver' in window;
  var state = null;
  var statusEl = null;

  /* ─── Konum saklama (geri donus / yenileme) ──────────────────────────── */

  function readStore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function pageKey() {
    return window.location.pathname + window.location.search;
  }

  // Tarayici eski (daha uzun) belgeye gore kaydirma konumunu geri yuklerse
  // yanlis urune duser. Kayitli konum bu adrese aitse geri yuklemeyi biz yapariz.
  var pending = (function () {
    var nav = window.performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')[0]
      : null;
    var type = nav ? nav.type : '';
    if (type !== 'back_forward' && type !== 'reload') return null;

    // Bu sayfa "tikla-yukle" modunda degilse (or. numarali sayfalamaya geri
    // donulduyse) eski kayit baska bir belge duzenine aittir: karisma,
    // tarayici kendi konum geri yuklemesini yapsin.
    var trig = document.querySelector(TRIGGER);
    var root = trig && trig.closest('[data-pagination-type]');
    if (!trig || (root && root.getAttribute('data-pagination-type') !== 'click')) return null;

    var saved = readStore();
    if (!saved || saved.u !== pageKey()) return null;
    if (Date.now() - (saved.t || 0) > STORE_TTL) return null;

    try { history.scrollRestoration = 'manual'; } catch (e) { return null; }
    return saved;
  })();

  // Onceki ziyarette yarida kalmis bir geri yukleme bu gecmis girdisini
  // 'manual' birakmis olabilir; biz ustlenmiyorsak tarayiciya geri ver.
  if (!pending) {
    try { if (history.scrollRestoration === 'manual') history.scrollRestoration = 'auto'; } catch (e) {}
  }

  var userMoved = false;

  // Geri / ileri ile tema icerigi yeniden cizerken (adres hemen degisir,
  // icerik sonra gelir) eski izgaradan adres yazilmasin.
  var frozenUntil = 0;

  function shown(el) {
    return !!el && el.getClientRects().length > 0;
  }

  // Tarayicinin "kaydirma capasi" (Chrome / Android), ustune icerik eklenince
  // ekrandaki seyi yerinde tutar: kullanici listenin altindaki icerige
  // bakarken yer tutucular / urunler ekranin ustune eklenir, altta ne varsa
  // (SEO metni) o gorunmeye devam eder. Yukleme boyunca kapatilir; Safari'de
  // zaten yoktur, davranis esitlenir: eklenen kartlar bulunulan yerde belirir.
  var anchorTimer = null;
  function holdAnchor(on) {
    var root = document.documentElement;
    clearTimeout(anchorTimer);
    if (on) {
      root.classList.add('fk-ss-busy');
      return;
    }
    // Yeni yerlesim bir sonraki karede uygulanir; sinif o zamana kadar kalsin.
    anchorTimer = setTimeout(function () { root.classList.remove('fk-ss-busy'); }, 400);
  }

  function preloadPx() {
    var screens = Math.round((window.innerHeight || 0) * PRELOAD_SCREENS);
    return Math.max(PRELOAD_PX, screens);
  }

  function atLimit() {
    var narrow = window.matchMedia && window.matchMedia('(max-width: 719px)').matches;
    return state.cards.length >= (narrow ? MAX_CARDS_MOBILE : MAX_CARDS);
  }

  // Adres degisikligi yalnizca "kalinan yer" bilgisidir, yeni bir sayfa
  // goruntuleme degildir. GTM / GA4, history.replaceState'i sarmalayip her
  // cagrida page_view gonderiyor (yukari kaydirmada bile); bu yuzden
  // tarayicinin kendi (prototip) metodu kullanilir. Yuklenen her sayfa
  // page_view sayilsin istenirse dogru yer burasi degil, onGridMutation'dir
  // (sayfa basina tek dataLayer.push).
  function setUrl(url) {
    try {
      var native = window.History && History.prototype.replaceState;
      (native || history.replaceState).call(history, history.state, '', url);
      return true;
    } catch (e) { /* Safari: kisa surede cok fazla cagri */
      return false;
    }
  }

  function cardKey(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    return link.pathname.split('/products/')[1] || '';
  }

  // Ust kenari ekranin ustune en yakin kart (ikili arama; kartlar belge sirasinda).
  function anchorCard() {
    var cards = state.cards;
    if (!cards.length) return null;
    var low = 0;
    var high = cards.length - 1;
    var found = -1;
    while (low <= high) {
      var mid = (low + high) >> 1;
      if (cards[mid].getBoundingClientRect().bottom > TOP_PX) {
        found = mid;
        high = mid - 1;
      } else {
        low = mid + 1;
      }
    }
    return cards[found === -1 ? cards.length - 1 : found];
  }

  function syncPosition(writeUrl) {
    if (!state || !state.cards.length || !shown(state.grid)) return;
    if (Date.now() < frozenUntil) return;
    var card = anchorCard();
    if (!card || !card.isConnected) return;

    var page = parseInt(card.getAttribute('data-fk-page'), 10) || state.firstPage;
    if (writeUrl !== false && page !== state.urlPage) {
      var url = new URL(window.location.href);
      if (page > 1) url.searchParams.set('page', String(page));
      else url.searchParams.delete('page');
      if (setUrl(url.pathname + url.search + url.hash)) state.urlPage = page;
    }

    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({
        u: pageKey(),
        k: cardKey(card),
        top: Math.round(card.getBoundingClientRect().top),
        y: Math.round(window.scrollY),
        f: state.firstPage,
        t: Date.now()
      }));
    } catch (e) { /* depolama kapali */ }
  }

  var syncTimer = null;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { syncPosition(true); }, 150);
  }

  function applyRestore() {
    if (!pending || userMoved) return;
    var target = null;
    if (state && pending.k) {
      for (var i = 0; i < state.cards.length; i++) {
        if (cardKey(state.cards[i]) === pending.k) { target = state.cards[i]; break; }
      }
    }
    if (target && shown(target)) {
      window.scrollTo(0, window.scrollY + target.getBoundingClientRect().top - pending.top);
    } else if (!state || pending.f === state.firstPage) {
      // Ayni belge duzeni: eski kaydirma konumu gecerli.
      if (typeof pending.y === 'number') window.scrollTo(0, pending.y);
    } else {
      // Kart artik bu sayfada yok (siralama degismis olabilir) ve liste baska
      // sayfadan basliyor: eski konum anlamsiz, listenin basina git.
      window.scrollTo(0, Math.max(0, window.scrollY + state.grid.getBoundingClientRect().top - 160));
    }
  }

  function finishRestore() {
    applyRestore();
    pending = null;
    try { history.scrollRestoration = 'auto'; } catch (e) {}
  }

  /* ─── Yardimcilar ────────────────────────────────────────────────────── */

  function nextLink() {
    var link = state ? state.trigger.querySelector('a[href]') : null;
    return link && link.getAttribute('href') ? link : null;
  }

  function announce(message) {
    if (!statusEl) {
      statusEl = document.createElement('div');
      statusEl.className = 'fk-ss-sr';
      statusEl.setAttribute('role', 'status');
      statusEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(statusEl);
    }
    statusEl.textContent = message;
  }

  function firstPageOf(grid, hasNext) {
    var offset = parseInt(grid.getAttribute('data-gtm-start-index'), 10);
    if (offset === 0) return 1;

    var section = grid.closest('[data-collection-items-per-page]');
    var perPage = section ? parseInt(section.getAttribute('data-collection-items-per-page'), 10) : 0;
    // Arama bolumunde sayfa boyutu yazmaz; sonraki sayfa varsa bu sayfa doludur.
    if (!(perPage > 0) && hasNext) perPage = Array.prototype.filter.call(grid.children, isCard).length;
    if (offset > 0 && perPage > 0) return Math.floor(offset / perPage) + 1;

    var fromUrl = parseInt(new URL(window.location.href).searchParams.get('page'), 10);
    return fromUrl > 1 ? fromUrl : 1;
  }

  function isCard(node) {
    return node.nodeType === 1 && node.tagName !== 'STYLE' && node.tagName !== 'SCRIPT' && node.tagName !== 'LINK' &&
      !node.classList.contains('fk-ss-skel');
  }

  function tagCards(nodes, page) {
    Array.prototype.forEach.call(nodes, function (node) {
      if (!isCard(node) || node.hasAttribute('data-fk-page')) return;
      node.setAttribute('data-fk-page', String(page));
      state.cards.push(node);
    });
  }

  // Tema sayaci hep "1-N" yazar; liste 2. veya sonraki sayfadan basliyorsa duzelt.
  function updateCount() {
    var offset = parseInt(state.grid.getAttribute('data-gtm-start-index'), 10) || 0;
    if (offset === 0) return;

    var partial = state.grid.closest('[data-partial]');
    var strings = window.theme && window.theme.strings && window.theme.strings.pagination;
    if (!partial || !strings || !strings.viewing) return;

    var countEl = partial.querySelector('[data-pagination-item-count]');
    var isSearch = partial.dataset.searchResultsCount !== undefined;
    var total = isSearch ? partial.dataset.searchResultsCount : partial.dataset.collectionProductsCount;
    if (!countEl || !total) return;

    var range = (offset + 1) + '-' + (offset + state.cards.length);
    countEl.textContent = strings.viewing.replace('{{ of }}', range).replace('{{ total }}', total) +
      ' ' + (isSearch ? strings.results : strings.products);
  }

  function renderPrevLink() {
    var old = document.querySelector('.fk-ss-prev');
    if (old) old.remove();
    if (state.firstPage <= 1) return;

    var url = new URL(window.location.href);
    if (state.firstPage - 1 > 1) url.searchParams.set('page', String(state.firstPage - 1));
    else url.searchParams.delete('page');

    var wrap = document.createElement('div');
    wrap.className = 'fk-ss-prev';
    var link = document.createElement('a');
    link.className = 'btn btn--secondary'; // alttaki "Daha fazla" butonuyla ayni gorunum
    link.href = url.pathname + url.search;
    link.textContent = TEXT.prev;
    // Acilan sayfa en ustten degil, urunlerin basindan baslasin (init'e bak).
    link.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      try { sessionStorage.setItem(CONTINUE_KEY, link.pathname + link.search); } catch (e) {}
    });
    wrap.appendChild(link);
    state.grid.parentNode.insertBefore(wrap, state.grid);
  }

  function refreshMode() {
    var link = nextLink();
    var auto = !!link && hasIO && !state.fallback && state.autoLeft > 0 && !atLimit();
    state.trigger.classList.toggle('fk-ss--auto', auto);
    state.trigger.classList.toggle('fk-ss--end', !link);
    if (link && !state.loading && !state.label) state.label = link.textContent.trim();
  }

  /* ─── Yer tutucu kartlar ─────────────────────────────────────────────── */

  // Gelecek sayfada kac urun var: sayfa boyutu, kalan urun daha azsa o kadar.
  function skeletonCount() {
    var per = state.perPage;
    var partial = state.grid.closest('[data-partial]');
    var total = partial
      ? parseInt(partial.dataset.collectionProductsCount || partial.dataset.searchResultsCount, 10)
      : NaN;
    var offset = parseInt(state.grid.getAttribute('data-gtm-start-index'), 10) || 0;
    var left = total - offset - state.cards.length;
    var count = left > 0 ? Math.min(per, left) : per;
    return Math.max(0, Math.min(count, SKELETON_MAX));
  }

  // Izgaranin sonuna, son kartla ayni olcude yer tutucular ekler. Izgaranin
  // kendi sutun duzenine oturduklari icin gelen urunler tam yerlerine gelir.
  function addSkeleton() {
    removeSkeleton();
    var sample = state.cards.length ? state.cards[state.cards.length - 1] : null;
    if (!sample || !sample.isConnected || !shown(sample)) return;

    var box = sample.getBoundingClientRect();
    if (!(box.width > 0 && box.height > 0)) return;
    var media = sample.querySelector('.product-item__media');
    var mediaHeight = media ? media.getBoundingClientRect().height : 0;
    if (!(mediaHeight > 0) || mediaHeight > box.height) mediaHeight = box.height * 0.84;

    var count = skeletonCount();
    if (!count) return;

    var fragment = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var card = document.createElement('div');
      card.className = 'fk-ss-skel';
      card.setAttribute('aria-hidden', 'true');
      card.style.minHeight = Math.round(box.height) + 'px';
      var block = document.createElement('div');
      block.className = 'fk-ss-skel__media';
      block.style.paddingTop = (mediaHeight / box.width * 100).toFixed(3) + '%';
      card.appendChild(block);
      var line = document.createElement('div');
      line.className = 'fk-ss-skel__line';
      card.appendChild(line);
      var short = document.createElement('div');
      short.className = 'fk-ss-skel__line fk-ss-skel__line--short';
      card.appendChild(short);
      state.skeleton.push(card);
      fragment.appendChild(card);
    }
    state.grid.appendChild(fragment);
  }

  function removeSkeleton() {
    if (!state || !state.skeleton.length) return;
    state.skeleton.forEach(function (card) {
      if (card.parentNode) card.parentNode.removeChild(card);
    });
    state.skeleton = [];
  }

  /* ─── Yukleme ────────────────────────────────────────────────────────── */

  function beginLoad(byUser, byKeyboard) {
    state.loading = true;
    state.focusNew = !!(byUser && byKeyboard) || state.trigger.contains(document.activeElement);
    state.trigger.classList.add('fk-ss--loading');
    holdAnchor(true);
    addSkeleton();
    announce(TEXT.loading);
    clearTimeout(state.watchdog);
    state.watchdog = setTimeout(onStall, WATCHDOG_MS);
  }

  function endLoad() {
    clearTimeout(state.watchdog);
    state.loading = false;
    state.trigger.classList.remove('fk-ss--loading');
    removeSkeleton();
    holdAnchor(false);
  }

  // Yukleme bitmedi (ag hatasi vb.): butonu normal baglanti olarak geri ver.
  function onStall() {
    if (!state || !state.loading) return;
    endLoad();
    state.fallback = true;
    var link = nextLink();
    if (link && state.label) link.textContent = state.label;
    refreshMode();
    announce('');
  }

  function maybeAuto() {
    if (!state || state.loading || state.fallback) return;
    if (!state.near || state.autoLeft <= 0 || atLimit()) return;
    // Erken yukleme payi genis: kisa listelerde tetikleyici sayfa acilir
    // acilmaz "yakin" sayilabilir. Kullanici hic kaydirmadan yukleme yapma.
    if (!((window.scrollY || window.pageYOffset || 0) > 0)) return;

    var link = nextLink();
    if (!link) return;

    state.autoLeft -= 1;
    beginLoad(false, false);

    // Temanin tiklama dinleyicisi henuz bagli degilse baglanti sayfayi
    // degistirmesin: bu dinleyici temaninkinden SONRA calisir.
    var handled = true;
    var guard = function (event) {
      if (!event.defaultPrevented) {
        event.preventDefault();
        handled = false;
      }
    };
    // Tiklama, baglanti belgeden bir anligina ayrilmisken gonderilir. Tema
    // dinleyicisi baglantinin kendisinde oldugu icin calisir; belge duzeyindeki
    // dinleyiciler (GTM tiklama tetikleyicileri vb.) olayi hic gormez ve
    // kullanici tiklamasi saymaz. Sayfanin degismesini engelleyen sey ayrik
    // olmasi DEGIL, temanin preventDefault'u ve yukaridaki guard'dir:
    // guard kaldirilmamali.
    var parent = link.parentNode;
    var next = link.nextSibling;
    link.addEventListener('click', guard);
    state.synthetic = true;
    parent.removeChild(link);
    try {
      link.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
    } finally {
      parent.insertBefore(link, next);
      state.synthetic = false;
      link.removeEventListener('click', guard);
      // Cikar-tak islemi "tema tetikleyiciyi yeniledi" sanilmasin.
      if (state.trigObserver) state.trigObserver.takeRecords();
    }

    if (handled) return;

    // Tema hazir degil: geri al, biraz sonra yeniden dene.
    endLoad();
    state.autoLeft += 1;
    state.retries += 1;
    if (state.retries <= 5) {
      setTimeout(maybeAuto, 300 * state.retries);
    } else {
      state.autoLeft = 0; // buton gorunur kalir; tiklaninca normal sayfa gecisi olur
      refreshMode();
    }
  }

  function onGridMutation(records) {
    if (!state) return;

    var cards = [];
    records.forEach(function (record) {
      Array.prototype.forEach.call(record.addedNodes, function (node) {
        if (node.nodeType !== 1 || node.parentNode !== state.grid) return;
        // Her kartin onunde ayni <style> blogu gelir; ilk sayfadakiler yeterli.
        // Izgarada hic kopya yoksa (ilk sayfada urun karti yoktu) ilkini birak.
        if (node.tagName === 'STYLE') {
          if (state.styleKept) node.remove();
          else state.styleKept = true;
          return;
        }
        if (isCard(node) && !node.hasAttribute('data-fk-page')) cards.push(node);
      });
    });
    if (!cards.length) return;

    var focusNew = state.focusNew;
    endLoad();
    state.pages += 1;
    state.retries = 0;
    state.fallback = false; // yukleme basarili: tema butonu yeniden bagladi
    state.focusNew = false;

    tagCards(cards, state.firstPage + state.pages - 1);
    updateCount();
    refreshMode();
    announce(TEXT.loaded.replace('{n}', String(cards.length)));

    if (focusNew) {
      var first = cards[0];
      var focusTarget = first.matches('a[href]') ? first : first.querySelector('a[href]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    // Tetikleyici asagi kaydi: eski "yakin" bilgisi gecersiz. Yeniden gozleme
    // almak guncel durumla taze bir bildirim uretir; hala yakinsa
    // onTriggerVisibility yuklemeyi baslatir.
    state.near = false;
    if (state.io) {
      state.io.unobserve(state.trigger);
      state.io.observe(state.trigger);
    }
  }

  // Tema yaniti isledi (tetikleyici yenilendi) ama yeni kart gelmedi:
  // bekci suresini beklemeden yuklemeyi kapat.
  function onTriggerMutation() {
    if (!state || !state.loading) return;
    endLoad();
    state.autoLeft = 0; // buton gizli kalmasin; kullanici isterse yeniden basar
    refreshMode();
    announce('');
  }

  function onTriggerVisibility(entries) {
    if (!state) return;
    state.near = entries[entries.length - 1].isIntersecting;
    if (state.near) maybeAuto();
  }

  /* ─── Kurulum ────────────────────────────────────────────────────────── */

  function detach() {
    if (!state) return;
    clearTimeout(state.watchdog);
    removeSkeleton();
    if (state.loading) holdAnchor(false);
    if (state.gridObserver) state.gridObserver.disconnect();
    if (state.trigObserver) state.trigObserver.disconnect();
    if (state.io) state.io.disconnect();
    state = null;
  }

  function attach() {
    var grid = document.querySelector(GRID);
    var trigger = document.querySelector(TRIGGER);
    if (state && state.grid === grid && state.trigger === trigger) return;

    var replaced = !!state;
    detach();
    frozenUntil = 0;
    if (!grid || !trigger) return;

    // Yalnizca temanin "tikla-yukle" modunda calis.
    var root = grid.closest('[data-pagination-type]');
    if (root && root.getAttribute('data-pagination-type') !== 'click') return;

    var linkNow = trigger.querySelector('a[href]');
    var firstPage = firstPageOf(grid, !!(linkNow && linkNow.getAttribute('href')));
    var urlPage = parseInt(new URL(window.location.href).searchParams.get('page'), 10);

    state = {
      grid: grid,
      trigger: trigger,
      firstPage: firstPage,
      urlPage: urlPage > 1 ? urlPage : 1,
      pages: 1,
      cards: [],
      skeleton: [],
      perPage: 0,
      autoLeft: AUTO_PAGES,
      loading: false,
      synthetic: false,
      fallback: false,
      focusNew: false,
      near: false,
      retries: 0,
      label: '',
      styleKept: !!grid.querySelector('style'),
      watchdog: null,
      gridObserver: null,
      trigObserver: null,
      io: null
    };

    tagCards(grid.children, firstPage);
    state.perPage = state.cards.length;
    trigger.classList.add('fk-ss');
    renderPrevLink();
    refreshMode();

    // Sira onemli: izgara gozlemcisi tetikleyici gozlemcisinden once kurulur,
    // boylece kart gelen yuklemeyi once o kapatir.
    state.gridObserver = new MutationObserver(onGridMutation);
    state.gridObserver.observe(grid, { childList: true });
    state.trigObserver = new MutationObserver(onTriggerMutation);
    state.trigObserver.observe(trigger, { childList: true });

    if (hasIO) {
      state.io = new IntersectionObserver(onTriggerVisibility, {
        rootMargin: '0px 0px ' + preloadPx() + 'px 0px'
      });
      state.io.observe(trigger);
    }

    // Filtre / siralama ile liste yenilendi ve kullanici asagilardaydi:
    // yeni (kisa) listenin basina getir, belgenin sonunda kalmasin.
    if (replaced && !pending) {
      var top = grid.getBoundingClientRect().top;
      if (top < 0) window.scrollTo(0, Math.max(0, window.scrollY + top - 160));
    }
  }

  var lastScrollY = 0;
  var lastScrollAt = 0;

  function onScroll() {
    scheduleSync();
    if (!state || state.loading || state.fallback || state.autoLeft <= 0) return;

    var now = Date.now();
    var elapsed = now - lastScrollAt;
    if (elapsed < 60) return;
    var y = window.scrollY || window.pageYOffset || 0;
    // Uzun aradan sonraki ilk olayda hiz olculemez.
    var speed = elapsed < 400 ? (y - lastScrollY) / elapsed : 0;
    lastScrollY = y;
    lastScrollAt = now;

    // Tetikleyici sayfa acilirken zaten "yakin"sa gozlemci yeniden haber
    // vermez; ilk kaydirmada yuklemeyi buradan baslat.
    if (state.near) {
      maybeAuto();
      return;
    }

    // Hizli asagi kaydirma: bu hizla listenin sonuna yukleme suresinden once
    // varilacaksa beklemeden yukle.
    if (speed > FAST_PX_MS && shown(state.trigger)) {
      var distance = state.trigger.getBoundingClientRect().top - (window.innerHeight || 0);
      if (distance < speed * FAST_AHEAD_MS) {
        state.near = true;
        maybeAuto();
      }
    }
  }

  function onClickCapture(event) {
    if (!state || state.synthetic) return;
    var target = event.target;
    var link = target && target.closest ? target.closest('a[href]') : null;
    if (!link) return;

    // Urune gidilirken adresi ve konumu hemen kaydet.
    if (state.grid.contains(link)) {
      syncPosition(true);
      return;
    }

    if (!state.trigger.contains(link)) return;

    var newTab = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0;
    if (state.fallback || atLimit() || newTab) {
      // Tema dinleyicisine ulasmasin: tarayici baglantiyi normal sekilde acar.
      event.stopPropagation();
      // Yeni sayfa en ustten degil, urunlerin basindan acilsin (init'e bak).
      if (!newTab) {
        try { sessionStorage.setItem(CONTINUE_KEY, link.pathname + link.search); } catch (e) {}
      }
      return;
    }

    if (state.loading) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    state.autoLeft = AUTO_PAGES;
    beginLoad(true, event.detail === 0);
  }

  function init() {
    attach();

    // Filtre / siralama degisince tema [data-partial] icerigini yeniler.
    var partial = document.querySelector('[data-partial]');
    if (partial) {
      new MutationObserver(attach).observe(partial, { childList: true });
    }
    document.addEventListener('shopify:section:load', attach);

    document.addEventListener('click', onClickCapture, true);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('popstate', function () { frozenUntil = Date.now() + 4000; });
    // Cikarken yalnizca konumu sakla; adres yazma (tarayiciya gore degisir).
    window.addEventListener('pagehide', function () {
      if (pending) { try { history.scrollRestoration = 'auto'; } catch (e) {} }
      syncPosition(false);
    });
    // Yukleme surerken urune gidilip geri donuldu (sayfa bellekten geri geldi):
    // yarim kalan istek iptal olmustur. Gostergeyi bekci suresi dolana kadar
    // dondurme; butonu hemen normal baglanti olarak geri ver.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted && state && state.loading) onStall();
    });

    announce(''); // canli bolge ilk duyurudan once hazir olsun

    // Sinirda "Daha fazla" ile gelinen yeni sayfa mi?
    var continued = false;
    try {
      continued = sessionStorage.getItem(CONTINUE_KEY) === pageKey();
      sessionStorage.removeItem(CONTINUE_KEY);
    } catch (e) {}

    if (!pending && !(continued && state)) return;

    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, function () { userMoved = true; }, { passive: true, once: true });
    });

    // Ustteki icerik (gorseller, sonradan gelen bantlar) yerlestikce konumu
    // tazele; kullanici kendisi kaydirmaya baslarsa birak.
    var place = pending ? applyRestore : function () {
      if (userMoved || !state) return;
      var start = document.querySelector('.fk-ss-prev') || state.grid;
      window.scrollTo(0, Math.max(0, window.scrollY + start.getBoundingClientRect().top - 140));
    };
    var finish = pending ? finishRestore : place;

    place();
    if (document.readyState === 'complete') {
      setTimeout(finish, 300);
    } else {
      window.addEventListener('load', function () {
        place();
        setTimeout(finish, 600);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
  Liste alti SEO metnini kisaltma - Fahhar
  -------------------------------------------------------------------------
  Koleksiyon sayfasinda urun listesinin altindaki uzun metin (AVADA SEO
  "after collection" blogu ve ayni bolumdeki SSS blogu) ilk birkac satira
  indirilir; "Devamini oku" ile acilir. Metin belgede kalir (yalnizca
  yuksekligi kirpilir), arama motorlari tamamini gorur.

  Bu bolum calismazsa metin eskisi gibi tam gorunur. Kapatmak icin bu
  blogu silmek yeterlidir. Gorunum: assets/fk-sonsuz-kaydirma.css (.fk-seo)
*/
(function () {
  'use strict';

  if (window.__fkSeoKisalt) return;
  window.__fkSeoKisalt = true;

  var LINES = 5;        // kapaliyken gorunen satir sayisi
  var MIN_HIDDEN = 240; // gizlenecek kisim bundan kisaysa hic kisaltma (px)

  var isTr = (document.documentElement.lang || 'tr').toLowerCase().indexOf('tr') === 0;
  var LABEL = isTr ? 'Devamını oku' : 'Read more';
  var count = 0;

  function expand(section, box, more) {
    if (!section.classList.contains('fk-seo--collapsed')) return;
    section.classList.remove('fk-seo--collapsed');
    box.style.maxHeight = '';
    if (more && more.parentNode) more.parentNode.removeChild(more);
  }

  function collapse(content) {
    var section = content.closest('.shopify-section');
    if (!section || section.classList.contains('fk-seo')) return;

    // Bolumde yalnizca AVADA bloklari varsa bolumun tamami (metin + SSS)
    // kisaltilir; baska bir uygulama blogu da varsa yalnizca metin.
    var blocks = section.querySelectorAll('.shopify-app-block');
    var onlyAvada = Array.prototype.every.call(blocks, function (block) {
      return /avada/i.test(block.id || '');
    });
    var box = content;
    if (onlyAvada) {
      while (box.parentElement && box.parentElement !== section) box = box.parentElement;
    } else {
      box = content.querySelector('.Avada-AfterContent__content-wrapper') || content;
    }

    var first = content.querySelector('p, h2, h3, li');
    if (!first || !box.getClientRects().length) return; // metin yok ya da gorunmuyor

    var lineHeight = parseFloat(window.getComputedStyle(first).lineHeight);
    if (!(lineHeight > 0)) lineHeight = 24;
    var start = first.getBoundingClientRect().top - box.getBoundingClientRect().top;
    var limit = Math.round(Math.max(0, start) + lineHeight * LINES);
    if (!(box.scrollHeight - limit >= MIN_HIDDEN)) return; // zaten kisa

    count += 1;
    if (!box.id) box.id = 'fk-seo-' + count;
    box.classList.add('fk-seo__box');
    box.style.maxHeight = limit + 'px';
    section.classList.add('fk-seo', 'fk-seo--collapsed');

    var more = document.createElement('div');
    more.className = 'fk-seo__more';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fk-seo__btn';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', box.id);
    button.textContent = LABEL;
    more.appendChild(button);
    box.parentNode.insertBefore(more, box.nextSibling);

    button.addEventListener('click', function () {
      expand(section, box, more);
      // Buton kalkti: odak acilan metne gecsin, sayfa oynamasin.
      if (!box.hasAttribute('tabindex')) box.setAttribute('tabindex', '-1');
      try { box.focus({ preventScroll: true }); } catch (e) {}
    });
    // Klavyeyle kirpilmis kisimdaki bir baglantiya gelinirse metni ac.
    box.addEventListener('focusin', function () { expand(section, box, more); });
  }

  function init() {
    var contents = document.querySelectorAll('.Avada-AfterContent__after-collection');
    Array.prototype.forEach.call(contents, function (content) {
      try { collapse(content); } catch (e) { /* metin tam gorunur kalir */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
